import script from "./NewsPageSwitcherMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageSwitcherMenu.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageSwitcherMenu.vue?vue&type=style&index=0&id=468f8d83&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468f8d83"]])

export default __exports__